import _ from 'lodash';

export type StatsDefinition = {
    [statName: string]: {
        editable: boolean;
        isTestStat?: true;
    };
};
export type Stats<T extends StatsDefinition> = { [key in keyof T]: number };

type EditableStatsDefinition<T extends StatsDefinition, B extends boolean> = {
    [k in keyof T as T[k] extends { editable: B } ? k : never]: T[k];
};

type TestStat<T extends StatsDefinition> = keyof {
    [k in keyof T as T[k] extends { isTestStat: true } ? k : never]: true;
};

function filterStatsDefinitionByEditable<T extends StatsDefinition, B extends boolean>(
    stats: T,
    isEditable: B,
): EditableStatsDefinition<T, B> {
    return _.fromPairs(
        Object.entries(stats).filter(([_statName, statDef]) => {
            return statDef.editable === isEditable;
        }),
    ) as EditableStatsDefinition<T, B>;
}

export function compileStatDefinition<T extends StatsDefinition>(stats: T) {
    const testStat = Object.entries(stats).find((entry) => entry[1].isTestStat)?.[0];

    return {
        editable: filterStatsDefinitionByEditable(stats, true),
        noneditable: filterStatsDefinitionByEditable(stats, false),
        all: stats,
        testStat: testStat as TestStat<T>,
    };
}
